export default "__VITE_ASSET__DjcKomgZ__"